import { Logo } from '@nrg/design-system';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AuthShell.module.css';

interface AuthShellProps {
  children: ReactNode;
}

export default function AuthShell({ children }: AuthShellProps) {
  const { t } = useTranslation('auth');
  const year = new Date().getFullYear();

  return (
    <div className={styles.shell}>
      <main className={styles.formColumn}>
        <div className={styles.formColumnInner}>
          <div className={styles.mobileLogo} aria-hidden="true">
            <Logo variant="group" tone="brand" size={40} />
          </div>
          <div className={styles.card}>{children}</div>
          <p className={styles.legal}>{t('shell.legal', { year })}</p>
        </div>
      </main>
      <aside className={styles.brand} aria-hidden="true">
        <div className={styles.brandInner}>
          <Logo variant="group" tone="inverse" size={56} />
          <p className={styles.tagline}>{t('shell.tagline')}</p>
        </div>
        <span className={styles.eyebrow}>{t('shell.eyebrow')}</span>
      </aside>
    </div>
  );
}
